import { AppPlatform, AppleAppStorePhasedReleaseState, GooglePlayStoreState, PhasedRelease } from '@/types';
import type { Destination } from '@/types/destinations';

export const mockPhasedReleaseForPlatform: (
    platform: AppPlatform,
    releasedAt: string,
    phasedReleasePercent?: number,
) => PhasedRelease | null = (platform, releasedAt, phasedReleasePercent) => {
    switch (platform) {
        case AppPlatform.Android: {
            const percent = phasedReleasePercent ?? 2;
            return {
                state: GooglePlayStoreState.InProgress,
                phasedReleasePercent: percent,
                startDate: releasedAt,
                dayNumber: 2,
                userFraction: percent / 100,
                isRunwayAcceleratedRollout: false,
                isRunwayPaused: false,
                isManuallyAcceleratedPhasedRollout: false,
                isOnBlackoutPeriod: false,
                isSuperseded: false,
            };
        }
        case AppPlatform.Ios: {
            const percent = phasedReleasePercent ?? 5;
            return {
                state: AppleAppStorePhasedReleaseState.Active,
                phasedReleasePercent: percent,
                startDate: releasedAt,
                dayNumber: 2,
                userFraction: percent / 100,
                isRunwayAcceleratedRollout: false,
                isRunwayPaused: false,
                isManuallyAcceleratedPhasedRollout: false,
                isOnBlackoutPeriod: false,
                isSuperseded: false,
            };
        }
        default:
            return null;
    }
};

export const mockDestinationPhasedReleases: (destinations: Destination[], releasedAt: string) => PhasedRelease[] = (
    destinations,
    releasedAt,
) =>
    destinations
        .map((destination): PhasedRelease | null => {
            const phasedRelease = mockPhasedReleaseForPlatform(destination.platform, releasedAt);
            if (!phasedRelease) {
                return null;
            }
            return {
                ...phasedRelease,
                destination: {
                    destinationId: destination.stepConfigId,
                    stepConfigId: destination.stepConfigId,
                    name: destination.name,
                    platform: destination.platform,
                    appStoreType: destination.appStoreType,
                    iconURL: destination.iconURL,
                },
            };
        })
        .filter((phasedRelease): phasedRelease is PhasedRelease => phasedRelease !== null);
